<template>
    <div class="box-second">
        <div class="title-crumb" style="justify-content: space-between;padding-right:1vw;">
            <el-breadcrumb separator-class="el-icon-arrow-right color3">
                <el-breadcrumb-item>绿色施工</el-breadcrumb-item>
                <el-breadcrumb-item>卸料平台</el-breadcrumb-item>
            </el-breadcrumb>
            <div>
                <el-button type="warning" size="mini" @click="handleEdit">参数配置</el-button>
            </div>
        </div>
        <div class="main">
            <div class="main-left">
                <div class="main-left-item" v-for="(item,index) in towerlist" :key="index" :class="{'curTower':towerId==item.id}" @click="changeTower(item)">
                    <p class="name nowrap">{{item.unloadName}}</p>
                    <p class="state color8" v-if="item.online=='离线'">离线</p>
                    <p class="state color10" v-else-if="item.online=='正常'" >正常</p>
                    <p class="state color9" v-else >{{item.online}}</p>
                    <p class="num nowrap">设备编号：{{item.verifyCode}}</p>
                </div>
            </div>
            <div class="main-right">
                <div class="main-right-first">
                    <div style="width:100%;height:5vh;position: relative;padding:0 1vw;display:flex;justify-content: space-between;align-items: center;">
                        <span style="font-size:2vh;">实时数据</span>
                        <span style="font-size:1.6vh;">设备数据时间：{{allPart.updateDate}}</span>
                    </div>
                    <div class="real-data" style="height:calc( 100% - 5vh )">
                        <p style="width:100%;text-align: left;height:5vh;">设备号：{{allPart.verifyCode}}</p>
                        <div style="height:calc( 100% - 5vh );width:100%;position: relative;display:flex;align-items: center;">
                            <span style="flex:1;">偏置值</span>
                            <div style="width:18vw;height:100%">
                                <div id="echart1" style="width:100%;height:100%"></div>
                                <!-- <div style="width:120px;height:40px;position: absolute;bottom: 2vh;left: calc( 50% - 60px );background:red;"></div> -->
                            </div>
                        </div>
                    </div>
                    <div class="real-data" style="height:calc( 100% - 5vh )">
                        <p style="width:100%;text-align: left;height:5vh;">设备名称：{{allPart.unloadName}}</p>
                        <div style="height:calc( 100% - 5vh );width:100%;position: relative;display:flex;align-items: center;">
                            <span style="flex:1;">预警重量</span>
                            <div style="width:18vw;height:100%">
                                <div id="echart2" style="width:100%;height:100%"></div>
                                <div style="width:120px;height:40px;position: absolute;bottom: 2vh;left: calc( 50% - 60px );color:red;display: flex;justify-content: center;align-items: center;">
                                    预警：{{allPart.customEarlyWarningWeight}}T
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="real-data" style="height:calc( 100% - 5vh )">
                        <p style="width:100%;text-align: left;height:5vh;">设备电量百分比 <span style="padding:0.5vh 1vh;background:#E7F1FB;min-width:5vh;">{{allPart.electricQuantity||0}}%</span></p>
                        <div style="height:calc( 100% - 5vh );width:100%;position: relative;display:flex;align-items: center;">
                            <span style="flex:1;">报警重量</span>
                            <div style="width:18vw;height:100%">
                                <div id="echart3" style="width:100%;height:100%"></div>
                                <div style="width:120px;height:40px;position: absolute;bottom: 2vh;left: calc( 50% - 60px );color:red;display: flex;justify-content: center;align-items: center;">
                                    报警：{{allPart.customAlarmWeight}}T
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 特种设备操作人员列表 .real-data-->
                <div class="main-right-first" style="margin-top:1vh;height:calc( 100% - 41vh );padding:1vh;">
                    <p style="text-align: left;padding:0 1vh;font-size:1vw;height:3vh;width:100%;display:flex;justify-content: space-between;align-items: center;">
                        <!-- <span>特种设备操作人员列表</span> -->
                        <el-date-picker
                          v-model="tableTime"
                          value-format="yyyy-MM-dd"
                          type="date"
                          @change="doFilter"
                          placeholder="选择日期">
                        </el-date-picker>
                    </p>
                    <div class="special-table">
                        <el-table
                            :data="tableData"
                            height="calc( 100% - 5vh )"
                            style="width: 100%">
                            <el-table-column
                                prop="index"
                                label="序号">
                            </el-table-column>
                            <el-table-column
                                prop="verifyCode"
                                label="设备号">
                            </el-table-column>
                            <el-table-column
                                prop="bias"
                                label="偏置值">
                            </el-table-column>
                            <el-table-column prop="weight" label="卸料重量">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.weight }}吨</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="status" label="设备状态">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.status=='0'" style="color:#67C23A;">正常</span>
                                    <span v-else-if="scope.row.status=='1'" style="color:#E6A23C;">预警</span>
                                    <span v-else-if="scope.row.status=='2'" style="color:#F56C6C;">报警</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="time"
                                label="监测时间">
                            </el-table-column>
                        </el-table>
                        <!-- 分页展示 -->
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[5, 10,20,50]"
                            :page-size="pageSize"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="totalItems"
                        ></el-pagination>
                    </div>
                </div>
            </div>
        </div>
        <!-- 维护标准窗口 -->
    <el-dialog
        title="参数配置"
        :visible.sync="editFormVisible"
        center
        :append-to-body="true"
        :lock-scroll="false"
        custom-class='tower-dig'
        class="add-form"
        width="800px"
    >
      <div class="config-con">
        <p class="config-con-item" v-for="(item,index) in configList" :key="index">
          <span style="display: inline-block;width: 10vw;">{{item.name}}</span>
          <span style="display: inline-block;width: 10vw;">单位：（{{item.unit}}）</span>
          <span style="display: inline-block;width: 20vw;">设备报警限位：<el-input v-model="item.val" placeholder="请输入" style="width:5vw;"></el-input> {{item.unit}}</span>
        </p>
      </div>
      <div slot="footer" class="dialog-footer" style="">
          <el-button @click="editFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="sumbitEditRow">确 定</el-button>
        <el-button type="info" @click="setDetfaule">恢复默认值</el-button>
      </div>
    </el-dialog>
    </div>
</template>
<script>
import HighCharts from 'highcharts'
import util from '../../untils/util'
import myHttp from '../../untils/port'
import base from '../../untils/base'
export default {
    data(){
        return{
            groupId:'',
            towerId:'',//当前卸料id
            deviceId:'',//当前卸料deviceId
            towerlist:[],//卸料设备列表
            allPart:{},//当前卸料信息
            towerH:{},//24小时数据
            tableData:[],//特种人员列表
            // websock: null,
            // timeRefrsh:null,
            showUrl:'',
            cameraData:{},//监控摄像头信息
            tableTime:util.myTime.getCurTime(),
            currentPage: 1,
            pageSize: 10,
            totalItems: 0,
            configList:[
                {name:'预警重量',val:'',unit:'T',default:'800'},
                {name:'报警重量',val:'',unit:'T',default:'1000'},
            ],
            editFormVisible:false,
        }
    },
    mounted(){
        this.groupId = util.session.get('groupId')
        this.getTowerList()
        this.setChart1()
    },
    created(){
        //页面刚进入时开启长连接
        
    },
    destroyed: function() {
        //页面销毁时关闭长连接
        //this.websocketclose();
        // if(this.timeRefrsh){
        //     window.clearTimeout(this.timeRefrsh)
        // }
    },
    methods:{
        //获取塔吊设备
        getTowerList(){
            var that = this
            myHttp.equipUnloadNavList({
                projectId:this.groupId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.navList||[]
                    for(var i=0;i<list.length;i++){
                        if(list[i].status=='0'){
                            list[i].online = '离线'
                        }else if(list[i].status=='1'){
                            list[i].online = '在线'
                        }else{
                            list[i].online = '异常'
                        }
                    }
                    that.towerlist = list
                    if(list.length>0 && that.towerId==''){
                        that.towerId = list[0].platformId
                        that.deviceId = list[0].verifyCode
                        // that.initWebSocket()
                    }
                    if(that.towerId!=''){
                        that.getRealInfo()
                        // that.getHour()
                        
                    }
                }
            })
        },
        getRealInfo(){
            var that = this
            myHttp.equipmentInformation({
                platformId:this.towerId,
                v:new Date().getTime()
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data||{}
                    data.angle = data.bias && ''!=data.bias?data.bias:0
                    that.allPart = data
                    that.configList[0].val = data.customEarlyWarningWeight||0
                    that.configList[1].val = data.customAlarmWeight||0
                    that.setChart1()
                }
                // that.timeRefrsh = setTimeout(function(){
                //     that.getRealInfo()
                // },60000)
                that.getPerson() //获取操作记录
            })
        },
        //获取监控视频
        // getVideo(serial,channel){
        //     var that = this
        //     myHttp.getYsToken().then(function(resp){
        //         if(resp.data.code=='200'){
        //             var ysToken = resp.data.data.accessToken||''
        //             that.showUrl = '/monitor/view/one.html?serial='+serial+'&channel='+channel+'&token='+ysToken
        //         }
        //     })
        // },
        //获取24小时监测数据
        // getHour(){
        //     var that = this
        //     myHttp.get24HourByTower({
        //         projectId:this.groupId,
        //         deviceId:this.deviceId
        //     }).then(function(resp){
        //         if(resp.data.code=='200'){
        //             var data = resp.data.data.tdTime
        //             that.towerH = data
        //             that.setChart1(data)
        //         }
        //     })
        // },
        //偏置值
        setChart1(){
            // 偏置值
            var bias = this.allPart.bias ||0
            var echart1 = this.$echarts.init(document.getElementById('echart1'))
            echart1.setOption({
                tooltip: {
                    formatter: '{a} <br/>{b} : {c}%'
                },
                series: [
                    {
                        name: '偏置值',
                        type: 'gauge',
                        min: -100,
                        max: 100,
                        radius: '80%',
                        axisLine: {            // 坐标轴线
                            lineStyle: {       // 属性lineStyle控制线条样式
                                color: [
                                    [1,new this.$echarts.graphic.LinearGradient(0, 0, 1, 0, [
                                        {
                                            offset: 0.8,
                                            color: "#ACBBFA"
                                        },
                                        {
                                            offset: 1,
                                            color: "#617AE5"
                                        }
                                        ])
                                    ]
                                ],
                                width: 10,
                                shadowColor: '#fff', //默认透明
                                shadowBlur: 10
                            }
                        },
                        splitLine: {           // 分隔线
                            length: 15,         // 属性length控制线长
                            lineStyle: {       // 属性lineStyle（详见lineStyle）控制线条样式
                                width: 3,
                                color: '#9198B2',
                            }
                        },
                        detail: {formatter: '{value}',fontSize:20},
                        data: [{value: bias, name: '偏置值'}]
                    }
                ]
            })
            var weight = this.allPart.weight||0 //当前重量
            // 预警重量\
            var earlyWarningWeight = this.allPart.earlyWarningWeight ||1000
            var echart2 = this.$echarts.init(document.getElementById('echart2'))
            echart2.setOption({
                tooltip: {
                    formatter: '{a} <br/>{b} : {c}%'
                },
                series: [
                    {
                        name: '偏置值',
                        type: 'gauge',
                        min: 0,
                        max: earlyWarningWeight,
                        radius: '80%',
                        axisLine: {            // 坐标轴线
                            lineStyle: {       // 属性lineStyle控制线条样式
                                color: [
                                    [1,new this.$echarts.graphic.LinearGradient(0, 0, 1, 0, [
                                        {
                                            offset: 0.8,
                                            color: "#ACBBFA"
                                        },
                                        {
                                            offset: 1,
                                            color: "#617AE5"
                                        }
                                        ])
                                    ]
                                ],
                                width: 10,
                                shadowColor: '#fff', //默认透明
                                shadowBlur: 10
                            }
                        },
                        splitLine: {           // 分隔线
                            length: 15,         // 属性length控制线长
                            lineStyle: {       // 属性lineStyle（详见lineStyle）控制线条样式
                                width: 3,
                                color: '#9198B2',
                            }
                        },
                        detail: {formatter: '{value}吨',fontSize:20},
                        data: [{value: weight, name: ''}]
                    }
                ]
            })
            // 报警重量
            var alarmWeight = this.allPart.alarmWeight ||1000
            var echart3 = this.$echarts.init(document.getElementById('echart3'))
            echart3.setOption({
                tooltip: {
                    formatter: '{a} <br/>{b} : {c}%'
                },
                series: [
                    {
                        name: '偏置值',
                        type: 'gauge',
                        min: 0,
                        max: alarmWeight,
                        radius: '80%',
                        axisLine: {            // 坐标轴线
                            lineStyle: {       // 属性lineStyle控制线条样式
                                color: [
                                    [1,new this.$echarts.graphic.LinearGradient(0, 0, 1, 0, [
                                        {
                                            offset: 0.8,
                                            color: "#ACBBFA"
                                        },
                                        {
                                            offset: 1,
                                            color: "#617AE5"
                                        }
                                        ])
                                    ]
                                ],
                                width: 10,
                                shadowColor: '#fff', //默认透明
                                shadowBlur: 10
                            }
                        },
                        splitLine: {           // 分隔线
                            length: 15,         // 属性length控制线长
                            lineStyle: {       // 属性lineStyle（详见lineStyle）控制线条样式
                                width: 3,
                                color: '#9198B2',
                            }
                        },
                        detail: {formatter: '{value}吨',fontSize:20},
                        data: [{value: weight, name: ''}]
                    }
                ]
            })
        },

        handleSizeChange(val) {
            this.pageSize = val
            this.handleCurrentChange(this.currentPage)
        },
        handleCurrentChange(val) {
            this.currentPage = val
            this.currentChangePage()
        },
        // 监控当前页码
        currentChangePage(list) {
            this.getPerson()
        },
        //获取人员操作记录
        getPerson(){
            var that = this
            myHttp.equipUnloadLogList({
                projectId:this.groupId,
                verifyCode:this.deviceId,
                date:this.tableTime,
                pageSize:this.pageSize,
                pageNum:this.currentPage,
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.pageInfo.list||[]
                    for(var i=0;i<list.length;i++){
                        list[i].index = that.pageSize * (parseInt(that.currentPage) - 1) + (i + 1)
                        if(parseFloat(list[i].weight)<parseFloat( that.configList[0].val)){
                            list[i].status = 0
                        }else if(parseFloat(list[i].weight)>=parseFloat( that.configList[0].val) && parseFloat(list[i].weight)<parseFloat( that.configList[1].val)){
                            list[i].status = 1
                        }else{
                            list[i].status = 2
                        }
                    }
                    that.tableData = list
                    that.totalItems = resp.data.data.pageInfo.total
                    if (that.tableData.length == 0) {
                        that.dataText = '暂无数据'
                    }
                }
            })
        },
        //获取班组id
        getTeamId(id){
            var list = this.towerlist
            var result = ''
            for(var i=0;i<list.length;i++){
                if(id==list[i].deviceId){
                    result = list[i].teamsId
                }
            }
            return result
        },
        //获取sn
        getSn(id){
            var list = this.towerlist
            var result = ''
            for(var i=0;i<list.length;i++){
                if(id==list[i].deviceId){
                    result = list[i].attendanceSn
                }
            }
            return result
        },

        //选择塔吊
        changeTower(obj){
            this.towerId = obj.platformId
            this.deviceId = obj.deviceId
            // window.clearTimeout(this.timeRefrsh)
            this.getRealInfo()
            // this.getHour()
            this.getPerson()
            // this.websocket.close();
            // this.initWebSocket()
        },

        //跳转查看信息
        attendInfo(row){
            this.$router.push({ name: 'specialPerson',params:{id:this.towerId,personId:row.personId,status:'1'} })
        },

        //跳转监控信息页面
        toDetail(id,channel,type){
            this.$router.push({path:'/monitCtl/'+id+'/'+channel+'/'+type})
        },

        //
        doFilter(){
            this.currentPage = 1
            this.getPerson()
        },
        // 跳转预警监测页面
        // deatilWarn(){
        //     var id = this.deviceId
        //     this.$router.push({path:'/perWarn/'+id})
        // },
        //initWebSocket长连接
        // initWebSocket(){ 
        //     if(this.websock){
        //         this.websock.close();
        //     }
        //     var that = this
        //     //初始化weosocket 
        //     if('WebSocket' in window){
        //         var url="ws://47.103.123.116:17001/equipwebsocket/"+this.deviceId;//ws地址;
        //         this.websocket = new WebSocket(url);
        //     }
        //     else{
        //         alert('Not support websocket')
        //     }
        //     //连接发生错误的回调方法
        //     this.websocket.onerror = function(){
        //         //setMessageInnerHTML("error");
        //     };
        //     //连接成功建立的回调方法
        //     this.websocket.onopen = function(event){
        //         //$("#serverinfo").hide();
        //         that.errorFlag = false
        //         that.timeOutObj=null;
        //     }
        //     //接收到消息的回调方法
        //     this.websocket.onmessage = function(event){
        //         if(event.data=="连接成功")return;
        //         var x=JSON.parse(event.data);
        //         if(x.tower.deviceId==that.deviceId){
        //             var data = x.tower
        //             data.angle = data.angle && ''!=data.angle?data.angle:0
        //             that.allPart = data
        //         }
        //     }
        //     //连接关闭的回调方法
        //     this.websocket.onclose = function(){
        //         this.timeOutObj=setTimeout(function(){
        //             that.initWebSocket();
        //         }, 60000);
        //         // $("#serverinfo").show();
        //         that.errorFlag = true
        //     }
        //     //监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常。
        //     window.onbeforeunload = function(){
        //         that.websocket.close();
        //     }
        // }, 
        handleEdit(){
            this.editFormVisible = true
            var that = this
            myHttp.findEquipUnloadPlatformConfig({
                projectId:this.groupId
            }).then(function(resp){
                console.log(resp)
                if(resp.data.code=='200'){
                    var data = resp.data.data
                    if(data){
                        that.configList[0].val = data.customEarlyWarningWeight
                        that.configList[1].val = data.customAlarmWeight
                    }
                }
            })
        },
        
        sumbitEditRow(){
            var that = this
            myHttp.setUpEquipUnloadPlatformConfig({
                projectId:this.groupId,
                customEarlyWarningWeight:this.configList[0].val,
                customAlarmWeight:this.configList[1].val,
            }).then(function(resp){
                if(resp.data.code=='200'){
                    that.$message.success('操作成功')
                    that.editFormVisible = false
                    that.getRealInfo()
                }else{
                    that.$message.error(resp.data.msg)
                }
            })
        },

        //设置默认值
        setDetfaule(){
            for(var i=0;i<this.configList.length;i++){
                this.configList[i].val = this.configList[i].default
            }
        },
    }
}
</script>
<style scoped>
    @import '../../assets/css/clock.css';
    .main-left{
        width: 10vw;
        height: 100%;
        position: relative;
        padding: 1vh 0.6vh;
        display: flex;
        flex-wrap: wrap;
        overflow: auto;
        background: #fff;
        align-content: flex-start;
    }
    .main-left-item{
        height: 7vh;
        width: 100%;
        position: relative;
        background: #E7F1FB;
        display: flex;
        flex-wrap: wrap;
        align-content: center;
        align-items: center;
        padding: 0.5vh;
        cursor: pointer;
        margin-top: 1vh;
    }
    .main-left-item p{
        height: 3vh;
        position: relative;
        text-align: left;
        display: flex;
        align-content: center;
        align-items: center;
    }
    .main-left-item .name{
        width: calc( 100% - 3vw );
        position: relative;
    }
    .main-left-item .state{
        width: 3vw;
        position: relative;
        justify-content: flex-end;
    }
    .main-left-item .num{
        width: 100%;
        position: relative;
    }
    .curTower{
        background: #1E369A;
    }
    .curTower .name,.curTower .state,.curTower .num{
        color: #fff;
    }

    .main-right{
        width: calc( 100% - 10vw );
        height: 100%;
        position: relative;
        padding: 0 1vh;
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;
        overflow:auto;
    }
    .main-right-first{
        width: 100%;
        height: 40vh;
        position: relative;
        border-radius: 6px;
        background: #fff;
        display: flex;
        flex-wrap: wrap;
        min-height: 260px;
    }
    .real-data{
        width: 33%;
        height: 100%;
        position: relative;
        padding: 1vh;
        display: flex;
        flex-wrap: wrap;
    }
    .real-data-l,.real-data-r{
        width:50%;
        height:calc( 100% - 3vh );
        padding:2vh 0;
    }
    .real-data-l-item{
        width:100%;
        display:flex;
        height:6vh;
        align-items: flex-end;
        margin-bottom: 1vh;
    }
    .real-data-l-item span{
        display: inline-block;
        /* width: 10vw; */
        margin-left: 0.8vw;
        height: 4vh;
        display: flex;
        align-content: center;
        align-items: center;
    }
    .real-data-l-item .abr{
        position: absolute;
        bottom: 2vh;
        left: 60%;
        width: 3.5vw;
        height: 3vh;
        /* line-height: 25px; */
        font-size: 0.8vw;
        text-align: center;
        color: #707070;
        background: #c5c1c1;
        background: url(../../assets/image/box.png) no-repeat;
        background-size: 100% 100%;
    }
    .real-clock{
        width: 33%;
        height: 100%;
        position: relative;
        padding: 1vh;
    }
    #wrap.real-clock-con{
        /* width:100%;
        height:calc( 100% - 3vh ); */
        /* padding:2vh 0; */
        margin-top: 3vh;
        width: 220px;
        height: 220px;
    }
    .main-dure{
        width:70%;
        height:100%;
        position: relative;
        padding-left:2vw;
        display:flex;
        flex-wrap:wrap;
        align-content: center;
        align-items: center;
        justify-content: center;
        justify-items: center;
    }
    .main-dure p{
        width: 100%;
        position: relative;
        height:4vh;
        display:flex;
     }
     .main-dure p span{
         width: 16.6%;
         position: relative;
     }
     .special-table{
         width: 100%;
         height: calc( 100% - 3vh );
         position: relative;
         padding: 1vh;
     }
     .no-photo{
         width:6vh;
         height:6vh;
         display: flex;
         justify-content: center;
         justify-items: center;
         align-content: center;
         background: #F5F7FA;
         flex-wrap: wrap;
         color:#C0C4CC;
     }
     .item-info{
        width: 100%;
        height: 5vh;
        position: relative;
        display: flex;
        align-content: center;
        align-items: center;
        justify-content: space-around;
        background: #E7F1FB;
    }
    .item-info .name{
        flex:1;
        text-align: center;
        
    }
    .item-info img{
        width:1.5vw;
        height: auto;
        position: relative;
        margin: 0 1vw;
    }
 
</style>
<style>
    .real-data .el-progress-bar__outer{
        background: #69BCFF;
    }
    @import '../../assets/css/common.css';
    .tower-dig .el-dialog__title{
      color: #0085FF;
    }
    .tower-dig .el-dialog__body,.tower-dig .el-dialog__footer{
      border-top: 1px solid #ddd;
    }
    .tower-dig span{
      font-weight: bold;
    }
    .tower-dig .el-dialog__header{
      text-align: left;
    }
    .config-con{
      display:flex;
      flex-wrap:wrap;
      width:100%;
      height:auto;
    }
    .config-con-item{
      width:100%;
      padding:1vh 0;
      display:flex;
      justify-content: space-around;
      align-items: center;
      align-content: center;
    }
</style>